export const isEmpty = (obj: any) => {
  if (obj === undefined || obj === null || obj === '') {
    return true
  } else {
    return false
  }
}
